import styles from './styles.module.css'

const OurClient = () => {
    return (
        <section className={styles['section-11']}>
            <div className={styles['logo-slideshow']}>
                <div className={styles['partner-logos']}>
                </div>
            </div>
        </section>
    );
};

export default OurClient;